import type { ReactNode } from "react";
import { MOBILE_AD_BOTTOM_MARGIN } from "../../common/constants.ts";
import { useLocal } from "../util/local.ts";

export const StickyBottomButtons = ({
	children,
	isInsideModal,
}: {
	children: ReactNode;
	isInsideModal?: boolean;
}) => {
	const { stickyFooterAd } = useLocal(["stickyFooterAd"]);

	let bottom;
	if (isInsideModal) {
		bottom = -15;
	} else {
		bottom = 0;
		if (stickyFooterAd) {
			bottom += MOBILE_AD_BOTTOM_MARGIN;
		}
	}

	return (
		<div
			className={`alert-bg-color alert-secondary rounded-top ${
				isInsideModal ? "py-2" : "p-2"
			} d-flex settings-buttons`}
			style={{ bottom }}
		>
			{children}
		</div>
	);
};
